import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './InlineErrorMessage.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Popper",
    {
      attrs: {
        "target-element": _vm.targetElement,
        placement: _vm.placement,
        "flip-behavior": ["right", "top-end"]
      }
    },
    [
      _c(
        "div",
        { ref: "error-dialog", staticClass: "error-dialog" },
        [
          _vm.error.fieldErrors
            ? _vm._l(_vm.error.fieldErrors, function(fieldError, i) {
                return _c("div", { key: i, staticClass: "error-message" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(fieldError.message || _vm.error.message) +
                      "\n            "
                  )
                ])
              })
            : _vm.error.message
            ? [
                _vm._v(
                  "\n            " + _vm._s(_vm.error.message) + "\n        "
                )
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-07160178";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Form/InlineErrorMessage.vue.js